import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermContactCalendarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_contact_calendar"}/>
}
